// extracted by mini-css-extract-plugin
module.exports = {"contents":"Rq-z","sectionHeading":"Sq-z"};